import { Formik } from 'formik'
import React, { useContext, useEffect, useState } from 'react'
import { Stack } from '@mui/material'
import { renderButton, renderCancelButton, renderTextField } from '@/shared/FormUtils'
import { fetchAPI } from '@/utility/NetworkUtils'
import UserContext from '@/context/UserContext'
import { sub } from 'date-fns'
import InventoryChits from '../components/InventoryChits'
import Loading from '@/shared/Loading'
import { renderSelectFieldFilterable } from '@/shared/FormUtils'
const AddToCartForm = ({
  item,
  onSubmit,
  onCancel,
  orderItem = null
}) => {
  const { user } = useContext(UserContext);
  const [ inventoryCount, setInventoryCount ] = useState(null)
  const [ availableOrders, setAvailableOrders ] = useState(null)
  
  useEffect(() => {
    if(item) {
      fetchInventoryCount()
      fetchAvailableOrders()
    }
  },[item])

   const fetchInventoryCount = async () => {
      setInventoryCount(null)
      fetchAPI(`/webapi/items/${item.id}/inventory_count`, (json)=> {
        if (!json.errors) {
          setInventoryCount(json)
        } else {
          console.log({
            errors: json.errors
          })
        }
      });
   }

  const fetchAvailableOrders = () => {
    setAvailableOrders(null)
    fetchAPI(`/webapi/orders/available_for_additions`, (json) => {
      if(!json.error) {
        setAvailableOrders(json.orders)
      }
    })
  }

  const isSubmitDisabled = (formikProps) => {
    const { quantity, order_id } = formikProps.values
    if(formikProps.isSubmitting) return true
    if(!quantity || quantity <= 0 || quantity > inventoryCount?.currently_in_warehouse) return true
    if(order_id == null) return true
    return false
  }
  const renderButtons = (formikProps) => {
    const { values: { order_id } } = formikProps
    const newOrder = order_id == "new"
    return (
      <Stack direction="row" spacing={2} justifyContent="flex-end" className="mt-4">
        {renderCancelButton("Cancel", onCancel)}
        {renderButton(
          newOrder ? "Create New Order" :
          orderItem ? "Save" : "Add to Order", formikProps.handleSubmit, {color:"green", disabled: isSubmitDisabled(formikProps)}
        )}
      </Stack>
    )
  }

  const submitForm = (values, formikProps) => {
    formikProps.setSubmitting(true)
    fetchAPI(`/order_items`, (json) => {
      formikProps.setSubmitting(false)
      if (!json.error) {
        if(json.new_order_id) {
          window.location = `/orders/${json.new_order_id}`
        }
        if(onSubmit) {
          onSubmit()
        }

      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {
      method: "POST",
      body: {
        order_item_id: orderItem ? orderItem.id : null,
        item_id: item.id,
        order_id: values.order_id,
        quantity: values.quantity,
        user_id: values.user_id
      }
    })
  }

  console.log({
    availableOrders,
    inventoryCount
  })
  if(!availableOrders || !inventoryCount) {
    return <Loading/>
  }

  const getInitialValues = () => {
    if(orderItem) {
      return {
        quantity: orderItem.quantity,
        item_id: orderItem.item_id,
        order_id: orderItem.order_id,
        user_id: orderItem.user_id
      }
    }else {
      return {
        item_id: item.id,
        user_id: user.id
      }
    }
  }



  
  const maxCount = (inventoryCount?.owned + inventoryCount?.expected_receiving)||0
  return (

    <Formik
      initialValues={getInitialValues()}
      onSubmit={submitForm}

    >
      {(formikProps) => (
        <Stack direction="column" spacing={2}>
          <div>
            <div class="text-emerald-900 text-4xl font-medium font-['Roboto'] pb-4 font-weight-[400]">
              {item.name}
            </div>
            {item.rental_cost && (
              <div className="w-[521px] h-12 justify-start">
                <span class="text-neutral-500 text-xs font-normal font-['Roboto'] uppercase leading-5 tracking-wide">Rental Price: </span>
                <span class="text-black text-base font-normal font-['Roboto'] leading-5">{"$"+parseFloat(item.rental_cost).toFixed(2)}<br/></span></div>
            )}
          </div>
          <div>
            <InventoryChits
              item={item}
              inventoryCount={inventoryCount}
            />
          </div>
          <div class="text-emerald-900 text-[20px] font-medium font-['Roboto'] leading-8 tracking-tight">
            {orderItem ? "Edit Quantity" : "Add to Order"}
          </div>
          {!orderItem && (
            renderSelectFieldFilterable("Order", "order_id", [
              {label: "Create a New Order", value: "new"},
              ...availableOrders.map(order => {return {label: `Order #${order.id} - ${order.title||""}`, value: order.id}})
            ],
            {required: true}
          ))}
          <div className="text-black text-[14px] mt-0]">
          {!orderItem && "To add to a new order, please go to the Order tab first and create the new order."}
          </div>
          {renderTextField('Quantity', 'quantity',
            {
              required: true,
              type: "number",
              min: 0,
              fieldProperties: {
                inputProps:{ min: 0, max: maxCount, type: "number", step: 1, onBlur: (e) => {
                  formikProps.setFieldValue("quantity", Math.min(parseInt(e.target.value), maxCount))
                }},
                min: 0,
                max: maxCount,
                type: "number",
              }
            }
          )}
          {renderButtons(formikProps)}
        </Stack>
      )}
    </Formik>
  )
}

export default AddToCartForm